import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PdfSettingsDesignModel, PdfSettingsModel, PdfSettingsPositionsModel } from '../../models';
import {
  PdfSettingsDiscountUnitEnum,
  PdfSettingsProductIdTypeEnum,
  PdfSettingsTableRowStyleEnum
} from '../../enums';

@Component({
  selector: 'rnpl-pdf-table',
  templateUrl: './pdf-table.component.html',
  styleUrls: ['./pdf-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfTableComponent {

  @Input() pdfSettings: PdfSettingsModel;
  @Input() currentShortYear: string;

  public rowStyleEnum = PdfSettingsTableRowStyleEnum;
  public discountUnitEnum = PdfSettingsDiscountUnitEnum;
  public productIdTypeEnum = PdfSettingsProductIdTypeEnum;

  get design(): PdfSettingsDesignModel {
    return this.pdfSettings.settings.design;
  }

  get positions(): PdfSettingsPositionsModel {
    return this.pdfSettings.settings.positions;
  }

}
